import styled from "styled-components";

export const FormButtonsDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: fixed;
    right: 20px;
    bottom: 20px;
`